export const CenteredProgress = () => (
  <div className="flex size-full items-center justify-center">
    <img src="/icons/waiter.svg" alt="Progress" />
  </div>
)
